// Global app data
const datastore = {}

datastore.layoutDoc = null

export default datastore
